(function () {
  'use strict';

  function initHero(hero) {
    if (!hero || hero.dataset.cleenyHeroReady === 'true') return;

    hero.dataset.cleenyHeroReady = 'true';

    var image = hero.querySelector('.cleeny-hero__image');

    if (!image || image.complete) {
      requestAnimationFrame(function () {
        hero.classList.add('is-ready');
      });
      return;
    }

    image.addEventListener('load', function () {
      hero.classList.add('is-ready');
    }, { once: true });

    image.addEventListener('error', function () {
      hero.classList.add('is-ready');
    }, { once: true });
  }

  function initAllHeroes(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cleeny-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllHeroes(document);
    });
  } else {
    initAllHeroes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllHeroes(event.target);
  });
})();